import React from "react";
import { WindowChanger } from "./window-changer";

const Fallback = () => <WindowChanger />;

export default Fallback;
